import { EMPLOYEE_DOCUMENT_HR_TYPES_VALUES } from 'domain/shared/core/constants';

export const PROCESS_ASSETS_CTO = 'DOCUMENT_STORAGE_OPERATIONAL_ASSETS_FE_CTO';
export const PROCESS_ASSETS_SUPPORTS = 'DOCUMENT_STORAGE_OPERATIONAL_ASSETS_FE_SUPPORTS'; // "PROCESS_SUPPORT_SE/SM;
export const READ_PROCESS_ASSETS = 'DOCUMENT_STORAGE_OPERATIONAL_ASSETS_READ';
export const UPLOAD_PROCESS_ASSETS = 'DOCUMENT_STORAGE_OPERATIONAL_ASSETS_UPLOAD';
export const UPDATE_PROCESS_ASSETS = 'DOCUMENT_STORAGE_OPERATIONAL_ASSETS_UPLOAD';
export const PUBLISH_PROCESS_ASSETS = 'DOCUMENT_STORAGE_OPERATIONAL_ASSETS_PUBLISH';
export const DOWNLOAD_PROCESS_ASSETS = 'DOCUMENT_STORAGE_OPERATIONAL_ASSETS_DOWNLOAD';

export const AVAILABLE_FILE_FORMATS = 'md,pdf,docx,xlsx';

export const PROCESS_ASSETS_STATUS = {
  UNPUBLISHED: 'UNPUBLISHED',
  PUBLISHED: 'PUBLISHED',
};

export const PROCESS_ASSETS_STATUS_VALUES = {
  UNPUBLISHED: 'Unpublished',
  PUBLISHED: 'Published',
};

export const OPERATIONAL_ASSETS_DOCUMENT_SECTIONS = {
  HR: 'HR',
};

export const OPERATIONAL_ASSETS_DOCUMENT_SECTIONS_VALUES = {
  HR: 'HR',
};

// Same with EMPLOYEE_DOCUMENT_HR_TYPES_VALUES
export const OPERATIONAL_ASSETS_DOCUMENT_HR_TYPES_VALUES = EMPLOYEE_DOCUMENT_HR_TYPES_VALUES;

// Temp - only HR
export const FILE_TYPES_BY_SECTIONS_ASSET_DOC = {
  [OPERATIONAL_ASSETS_DOCUMENT_SECTIONS.HR]: OPERATIONAL_ASSETS_DOCUMENT_HR_TYPES_VALUES,
};
//
